import React from "react";

// Files import
import SocialIcons from "../Buttons/SocialIcons/SocialIcons";
import StyledH3Heading from "../../common/components/styledH3Heading/StyledH3Heading";

const FollowUs = () => {
  return (
<div className="w-full LeftSideContainer yellow-border px-4 md:px-10 py-14 ">
<div className="w-full relative space-y-10 md:space-y-14 pb-14 text-start ">
      {/* Heading */}
      <div>
        <StyledH3Heading>Find Us On!</StyledH3Heading>
      </div>
      {/* Social Icons */}
      <div className="">
        <SocialIcons />
      </div>
    </div>
</div>

  
  );
};

export default FollowUs;
